import { render, staticRenderFns } from "./Emoji.vue?vue&type=template&id=0458d602&scoped=true"
import script from "./Emoji.vue?vue&type=script&lang=js"
export * from "./Emoji.vue?vue&type=script&lang=js"
import style0 from "./Emoji.vue?vue&type=style&index=0&id=0458d602&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0458d602",
  null
  
)

export default component.exports